import { searchModel } from 'APP/model/model';
import { SpaceUserRole } from 'APP/model/space/spaceModel.types';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { groupClassesMap } from 'STORE/Groups/Groups';
import { Space } from 'STORE/Spaces/Space';
import { User } from 'STORE/Users/User/User';

const GLOBAL_MIN_STRING_LENGTH = 3;
const SEARCH_RESULTS_OFFSET = 15;

const emptyResult = {
  groups: [],
  users: [],
  spaces: [],
  hasMoreResults: false,
};

export interface IGlobalSearchResult {
  users: User[];
  groups: Group[];
  spaces: Space[];
  hasMoreResults: boolean;
  cursor?: string;
}

export async function getGlobalSearchResults(
  searchValue: string,
  offset: number,
  cursor?: string
): Promise<IGlobalSearchResult> {
  if (searchValue.length < GLOBAL_MIN_STRING_LENGTH) {
    return emptyResult;
  }

  try {
    const {
      groups: groupsData,
      users: usersData,
      spaces: spacesData,
      hasMoreResults,
      cursor: cursorData,
    } = await searchModel.globalSearch({
      query: searchValue,
      limit: SEARCH_RESULTS_OFFSET,
      offset,
      cursor,
    });

    const users = usersData
      .map((user) => new User(Entities.usersStore, user))
      .filter((user) => {
        if (!Features.isBotEnabled()) {
          if (user.id && parseInt(user.id, 10) < 0) {
            return false;
          }
        }
        return !user.isMe;
      });

    const groups = groupsData
      .map((group) => {
        const GroupClass = groupClassesMap[group.type];

        return GroupClass ? new GroupClass(group, Entities.GroupsStore, Entities) : null;
      })
      .filter((group) => group !== null) as Group[];

    const spaces = Features.isSpacesEnabled()
      ? spacesData.map(
          (space) =>
            new Space({
              space,
              role: SpaceUserRole.Guest,
            })
        )
      : [];

    return { users, groups, spaces, hasMoreResults, cursor: cursorData };
  } catch {
    return emptyResult;
  }
}
